import { SenderWarningToast } from './components/SenderWarning';
import PropertySaveProvider from './components/PropertySaveProvider';
// src/App.js
// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './contexts/ThemeContext';
import LandingPage from './components/LandingPage';
import PasswordReset from './components/PasswordReset';
import AdminDashboard from './components/AdminDashboard';
import AgentWinds from './components/AgentWinds';
import InsightsDashboard from './components/InsightsDashboard';
import MailMarketing from './components/MailMarketing';
import MailMarketingMap from './components/MailMarketingMap';
import PropertyListView from './components/PropertyListView';
import Settings from './components/Settings';
import ClientManager from './components/ClientManager';
import ContactSelection from './components/ContactSelection';
import ImageUpload from './components/ImageUpload';
import PostcardSuccess from './components/PostcardSuccess';
import DigitalAds from './components/DigitalAds';
import CreativeManager from './components/CreativeManager';
import FacebookAd from './components/FacebookAd';
import GoogleAd from './components/GoogleAd';
import BlogManager from './components/BlogManager';
import ReviewsManager from './components/ReviewsManager';
import ReviewsPage from './components/ReviewsPage';
import EmailManager from './components/EmailManager';
import AgentReferral from './components/AgentReferral';
import AiStaging from './components/AiStaging';
import BlogPost from './components/BlogPost';
import BlogsPage from './components/BlogsPage';
import ChatPage from './components/ChatPage';
import SitemapXML from './components/SitemapXML';
import ApiDocs from './components/ApiDocs';
import AgentInfo from './components/AgentInfo';
import ContactUs from './components/ContactUs';
import AddContact from './components/AddContact';

import OrangeCountyPage from './components/OrangeCountyPage';
import LosAngelesCountyPage from './components/LosAngelesCountyPage';
import RiversideCountyPage from './components/RiversideCountyPage';
import SanBernardinoCountyPage from './components/SanBernardinoCountyPage';
import VenturaCountyPage from './components/VenturaCountyPage';
import SanLuisObispoCountyPage from './components/SanLuisObispoCountyPage';
import SanDiegoCountyPage from './components/SanDiegoCountyPage';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import ProtectedRoute from './components/ProtectedRoute';
import WestminsterHomesForSalePage from './components/WestminsterHomesForSalePage';
import LittleSaigonRealEstatePage from './components/LittleSaigonRealEstatePage';
import GardenGroveVietnameseHomesPage from './components/GardenGroveVietnameseHomesPage';
import FountainValleyRealEstatePage from './components/FountainValleyRealEstatePage';
import MidwayCityHomesForSalePage from './components/MidwayCityHomesForSalePage';
import WestminsterPhoDistrictHomesPage from './components/WestminsterPhoDistrictHomesPage';
import BolsaAvenueCorridorRealEstatePage from './components/BolsaAvenueCorridorRealEstatePage';
import VietnameseOwnedHomesWestminsterPage from './components/VietnameseOwnedHomesWestminsterPage';
import WestminsterFirstTimeHomebuyersPage from './components/WestminsterFirstTimeHomebuyersPage';
import WestminsterLuxuryHomesPage from './components/WestminsterLuxuryHomesPage';
import SellYourHomeWestminsterPage from './components/SellYourHomeWestminsterPage';
import WestminsterInvestmentPropertiesPage from './components/WestminsterInvestmentPropertiesPage';
import VietnameseCommunityHomesOCPage from './components/VietnameseCommunityHomesOCPage';
import WestminsterCondosForSalePage from './components/WestminsterCondosForSalePage';
import StantonHomesNearWestminsterPage from './components/StantonHomesNearWestminsterPage';
import WestminsterTownhomesPage from './components/WestminsterTownhomesPage';
import HuntingtonBeachVietnameseCommunityPage from './components/HuntingtonBeachVietnameseCommunityPage';
import WestminsterNewConstructionPage from './components/WestminsterNewConstructionPage';
import WestminsterHomeValueEstimatePage from './components/WestminsterHomeValueEstimatePage';
import SantaAnaVietnameseMarketRealEstatePage from './components/SantaAnaVietnameseMarketRealEstatePage';
import ElMonteVietnameseHomesPage from './components/ElMonteVietnameseHomesPage';
import RosemeadVietnameseRealEstatePage from './components/RosemeadVietnameseRealEstatePage';
import SanGabrielValleyVietnameseHomesPage from './components/SanGabrielValleyVietnameseHomesPage';
import AlhambraVietnameseCommunityPage from './components/AlhambraVietnameseCommunityPage';
import MontereyParkHomesForSalePage from './components/MontereyParkHomesForSalePage';
import TempleCityVietnameseHomesPage from './components/TempleCityVietnameseHomesPage';
import BaldwinParkVietnameseHomesPage from './components/BaldwinParkVietnameseHomesPage';
import WestCovinaVietnameseHomesPage from './components/WestCovinaVietnameseHomesPage';
import PomonaVietnameseCommunityHomesPage from './components/PomonaVietnameseCommunityHomesPage';
import DiamondBarHomesForSalePage from './components/DiamondBarHomesForSalePage';
import LongBeachVietnameseCommunityPage from './components/LongBeachVietnameseCommunityPage';
import LosAngelesVietnameseCommunityPage from './components/LosAngelesVietnameseCommunityPage';
import SouthElMonteHomesForSalePage from './components/SouthElMonteHomesForSalePage';
import HaciendaHeightsAsianCommunityPage from './components/HaciendaHeightsAsianCommunityPage';
import RowlandHeightsAsianCommunityPage from './components/RowlandHeightsAsianCommunityPage';
import MontebelloVietnameseHomesPage from './components/MontebelloVietnameseHomesPage';
import CovinaHomesForSalePage from './components/CovinaHomesForSalePage';
import ArcadiaAsianCommunityPage from './components/ArcadiaAsianCommunityPage';
import WalnutHomesForSalePage from './components/WalnutHomesForSalePage';
import LaPuenteVietnameseHomesPage from './components/LaPuenteVietnameseHomesPage';
import AnaheimVietnameseHomesForSalePage from './components/AnaheimVietnameseHomesForSalePage';
import BuenaParkVietnameseCommunityPage from './components/BuenaParkVietnameseCommunityPage';
import CypressHomesNearLittleSaigonPage from './components/CypressHomesNearLittleSaigonPage';
import LaPalmaHomesForSalePage from './components/LaPalmaHomesForSalePage';
import TustinVietnameseCommunityPage from './components/TustinVietnameseCommunityPage';
import VietnameseSpeakingRealtorLAPage from './components/VietnameseSpeakingRealtorLAPage';
import VietnameseSpeakingRealtorOCPage from './components/VietnameseSpeakingRealtorOCPage';
import MultigenerationalHomesVietnameseFamiliesPage from './components/MultigenerationalHomesVietnameseFamiliesPage';
import ADUHomesWestminsterVietnameseFamiliesPage from './components/ADUHomesWestminsterVietnameseFamiliesPage';
import FengShuiHomesOrangeCountyPage from './components/FengShuiHomesOrangeCountyPage';
import FloatingContactHub from './components/FloatingContactHub';
import './App.css';
// import Register from './components/Register';

function App() {
  return (
    <ThemeProvider>
      <HelmetProvider>
        <Router>
            <SenderWarningToast />
          <PropertySaveProvider>
        <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/search" element={<LandingPage directSearch={true} />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/listing/:listingKey" element={<LandingPage directListing={true} />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/agent-winds" element={<ProtectedRoute><AgentWinds /></ProtectedRoute>} />
          <Route path="/admin/insights" element={<ProtectedRoute><InsightsDashboard /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing" element={<ProtectedRoute><MailMarketing /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/map" element={<ProtectedRoute><MailMarketingMap /></ProtectedRoute>} />
          <Route path="/properties/list" element={<PropertyListView />} />
          <Route path="/admin/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/admin/client-manager" element={<ProtectedRoute><ClientManager /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/contacts" element={<ProtectedRoute><ContactSelection /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/upload" element={<ProtectedRoute><ImageUpload /></ProtectedRoute>} />
          <Route path="/admin/mail-marketing/success" element={<ProtectedRoute><PostcardSuccess /></ProtectedRoute>} />
          <Route path="/admin/digital-ads" element={<ProtectedRoute><DigitalAds /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/creative-manager" element={<ProtectedRoute><CreativeManager /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/ai-staging" element={<ProtectedRoute><AiStaging /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/facebook" element={<ProtectedRoute><FacebookAd /></ProtectedRoute>} />
          <Route path="/admin/digital-ads/google" element={<ProtectedRoute><GoogleAd /></ProtectedRoute>} />
          <Route path="/admin/blog-manager" element={<ProtectedRoute><BlogManager /></ProtectedRoute>} />
          <Route path="/admin/reviews" element={<ProtectedRoute><ReviewsManager /></ProtectedRoute>} />
          <Route path="/admin/email-manager" element={<ProtectedRoute><EmailManager /></ProtectedRoute>} />
          <Route path="/admin/agent-referral" element={<ProtectedRoute><AgentReferral /></ProtectedRoute>} />
          <Route path="/blogs" element={<BlogsPage onClose={() => window.history.back()} />} />
          <Route path="/reviews" element={<ReviewsPage onClose={() => window.history.back()} />} />
          <Route path="/agent" element={<AgentInfo />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/add-contact" element={<AddContact />} />
          <Route path="/orange-county" element={<OrangeCountyPage />} />
          <Route path="/los-angeles-county" element={<LosAngelesCountyPage />} />
          <Route path="/riverside-county" element={<RiversideCountyPage />} />
          <Route path="/san-bernardino-county" element={<SanBernardinoCountyPage />} />
          <Route path="/ventura-county" element={<VenturaCountyPage />} />
          <Route path="/san-luis-obispo-county" element={<SanLuisObispoCountyPage />} />
          <Route path="/san-diego-county" element={<SanDiegoCountyPage />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/sitemap.xml" element={<SitemapXML />} />
          <Route path="/api-docs" element={<ApiDocs />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/westminster-homes-for-sale" element={<WestminsterHomesForSalePage />} />
          <Route path="/little-saigon-real-estate" element={<LittleSaigonRealEstatePage />} />
          <Route path="/garden-grove-vietnamese-homes" element={<GardenGroveVietnameseHomesPage />} />
          <Route path="/fountain-valley-real-estate" element={<FountainValleyRealEstatePage />} />
          <Route path="/midway-city-homes-for-sale" element={<MidwayCityHomesForSalePage />} />
          <Route path="/westminster-pho-district-homes" element={<WestminsterPhoDistrictHomesPage />} />
          <Route path="/bolsa-avenue-corridor-real-estate" element={<BolsaAvenueCorridorRealEstatePage />} />
          <Route path="/vietnamese-owned-homes-westminster" element={<VietnameseOwnedHomesWestminsterPage />} />
          <Route path="/westminster-first-time-homebuyers" element={<WestminsterFirstTimeHomebuyersPage />} />
          <Route path="/westminster-luxury-homes" element={<WestminsterLuxuryHomesPage />} />
          <Route path="/sell-your-home-westminster" element={<SellYourHomeWestminsterPage />} />
          <Route path="/westminster-investment-properties" element={<WestminsterInvestmentPropertiesPage />} />
          <Route path="/vietnamese-community-homes-orange-county" element={<VietnameseCommunityHomesOCPage />} />
          <Route path="/westminster-condos-for-sale" element={<WestminsterCondosForSalePage />} />
          <Route path="/stanton-homes-near-westminster" element={<StantonHomesNearWestminsterPage />} />
          <Route path="/westminster-townhomes" element={<WestminsterTownhomesPage />} />
          <Route path="/huntington-beach-vietnamese-community-homes" element={<HuntingtonBeachVietnameseCommunityPage />} />
          <Route path="/westminster-new-construction" element={<WestminsterNewConstructionPage />} />
          <Route path="/westminster-home-value-estimate" element={<WestminsterHomeValueEstimatePage />} />
          <Route path="/santa-ana-vietnamese-market-real-estate" element={<SantaAnaVietnameseMarketRealEstatePage />} />
<Route path="/el-monte-vietnamese-homes" element={<ElMonteVietnameseHomesPage />} />
          <Route path="/rosemead-vietnamese-real-estate" element={<RosemeadVietnameseRealEstatePage />} />
          <Route path="/san-gabriel-valley-vietnamese-homes" element={<SanGabrielValleyVietnameseHomesPage />} />
          <Route path="/alhambra-vietnamese-community-homes" element={<AlhambraVietnameseCommunityPage />} />
          <Route path="/monterey-park-homes-for-sale" element={<MontereyParkHomesForSalePage />} />
          <Route path="/temple-city-vietnamese-homes" element={<TempleCityVietnameseHomesPage />} />
          <Route path="/baldwin-park-vietnamese-homes" element={<BaldwinParkVietnameseHomesPage />} />
          <Route path="/west-covina-vietnamese-homes" element={<WestCovinaVietnameseHomesPage />} />
          <Route path="/pomona-vietnamese-community-homes" element={<PomonaVietnameseCommunityHomesPage />} />
          <Route path="/diamond-bar-homes-for-sale" element={<DiamondBarHomesForSalePage />} />
          <Route path="/long-beach-vietnamese-community-homes" element={<LongBeachVietnameseCommunityPage />} />
          <Route path="/los-angeles-vietnamese-community-real-estate" element={<LosAngelesVietnameseCommunityPage />} />
          <Route path="/south-el-monte-homes-for-sale" element={<SouthElMonteHomesForSalePage />} />
          <Route path="/hacienda-heights-asian-community-homes" element={<HaciendaHeightsAsianCommunityPage />} />
          <Route path="/rowland-heights-asian-community-homes" element={<RowlandHeightsAsianCommunityPage />} />
          <Route path="/montebello-vietnamese-homes" element={<MontebelloVietnameseHomesPage />} />
          <Route path="/covina-homes-for-sale" element={<CovinaHomesForSalePage />} />
          <Route path="/arcadia-asian-community-homes" element={<ArcadiaAsianCommunityPage />} />
          <Route path="/walnut-homes-for-sale" element={<WalnutHomesForSalePage />} />
          <Route path="/la-puente-vietnamese-homes" element={<LaPuenteVietnameseHomesPage />} />
          <Route path="/anaheim-vietnamese-homes-for-sale" element={<AnaheimVietnameseHomesForSalePage />} />
          <Route path="/buena-park-vietnamese-community-homes" element={<BuenaParkVietnameseCommunityPage />} />
          <Route path="/cypress-homes-near-little-saigon" element={<CypressHomesNearLittleSaigonPage />} />
          <Route path="/la-palma-homes-for-sale" element={<LaPalmaHomesForSalePage />} />
          <Route path="/tustin-vietnamese-community-real-estate" element={<TustinVietnameseCommunityPage />} />
          <Route path="/vietnamese-speaking-realtor-los-angeles" element={<VietnameseSpeakingRealtorLAPage />} />
          <Route path="/vietnamese-speaking-realtor-orange-county" element={<VietnameseSpeakingRealtorOCPage />} />
          <Route path="/multigenerational-homes-vietnamese-families" element={<MultigenerationalHomesVietnameseFamiliesPage />} />
          <Route path="/adu-homes-westminster-vietnamese-families" element={<ADUHomesWestminsterVietnameseFamiliesPage />} />
          <Route path="/feng-shui-homes-orange-county" element={<FengShuiHomesOrangeCountyPage />} />
          {/* Other routes as needed */}
        </Routes>
          <FloatingContactHub />
        </div>
        </PropertySaveProvider>
          </Router>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
